export var getRoomTypeDescription = function getRoomTypeDescription(guestsLabel, guestsNumber, bedsLabel, bedsNumber) {
  if (bedsNumber !== undefined && guestsNumber !== undefined) {
    return "".concat(guestsLabel, ": ").concat(guestsNumber, " | ").concat(bedsLabel, ": ").concat(bedsNumber);
  }

  if (bedsNumber !== undefined) {
    return "".concat(bedsLabel, ": ").concat(bedsNumber);
  }

  if (guestsNumber !== undefined) {
    return "".concat(guestsLabel, ": ").concat(guestsNumber);
  }

  return null;
};